/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { graphql, Link } from 'gatsby';
import Img from 'gatsby-image';
import Axios from 'axios';

import styled from 'styled-components';

import 'moment/locale/nl-be';
import moment from 'moment';
import Card from '../components/UI/Card';
import Container from '../components/layout/Container';
import Layout from '../layout/defaultLayout';
import GameReviewCard from '../components/GameReviewCard';
import Tweets from '../components/Tweets';
import HeroMatches from '../components/heroMatches';
import slugify from '../utils/slugify';
import heroBG from '../images/backgrounds/bg-oxaco.jpg';
import logo from '../images/oxaco-logos/oxaco-logo-white.svg';
import trooper from '../images/sponsors/trooper.jpg';
import arrowRight from '../images/arrow-right.svg';

import '../stylesheets/index.sass';
import Calendar from '../components/Calendar';

const StyledHero = styled.div`
  height: 700px;
  position: relative;
  /* background: #eb01a5; */
  background-image: url(${heroBG}); /* fallback */
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0) 40%), url(${heroBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin: 0 auto;
  @media (max-width: 576px) {
    height: 475px;
  }
  #socialBar {
    position: absolute;
    right: 20px;
    top: 200px;
    display: flex;
    flex-direction: column;
    height: 300px;
    justify-content: space-between;
    z-index: 20;
    align-items: center;
    @media (max-width: 576px) {
      display: none;
    }
    &:before,
    &:after {
      content: '';
      height: 10%;
      width: 1px;
      position: relative;
    }
    &:before {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), #fff 30%);
    }
    &:after {
      background: linear-gradient(to top, rgba(0, 0, 0, 0.5), #fff 30%);
    }
  }
`;

const StyledJoinCTA = styled.div`
  background-color: #00600f;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding: 16px 10px;
  border-radius: 8px;
  margin-bottom: 40px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  h2 {
    font-size: 18px;
  }
  #ctaLogo {
    padding: 10px;
    width: 20%;
  }
  #ctaArrow {
    align-self: flex-end;
  }
`;

const SyledAnnouncements = styled.section`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto 60px auto;
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Index = ({ data }) => {
  const [clubGames, setClubGames] = useState(null);

  useEffect(() => {
    async function getClubGames() {
      const clubGamesData = await Axios.get(
        'https://vblcb.wisseq.eu/VBLCB_WebService/data/OrgMatchesByGuid?issguid=BVBL1189'
      );
      setClubGames(clubGamesData.data);
    }
    getClubGames();
    moment.locale('nl-be');
  }, []);

  return (
    <Layout home>
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <StyledHero>
          <Container>
            <div id="socialBar">
              <a href="https://www.facebook.com/oxacobbc" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 13 26" width="10" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m3.77689394 26v-11.6289062h-3.77689394v-4.6210938h3.77689394v-3.64101563c0-3.95585937 2.34393939-6.10898437 5.76628788-6.10898437 1.63977268 0 3.04810608.12695313 3.45681818.1828125v4.13359375h-2.3734848c-1.86136368 0-2.22083338.9140625-2.22083338 2.24960938v3.18398437h4.20037878l-.5761364 4.6210938h-3.62424238v11.6289062"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                </svg>
              </a>
              <a href="https://twitter.com/oxacobbc" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 26 21" width="15" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m23.3273828 5.23566346c.0165039.22958654.0165039.45922356.0165039.6888101 0 7.00269234-5.3616367 15.07143754-15.16114842 15.07143754-3.01904687 0-5.82359375-.8692284-8.18273828-2.3779472.42894922.0491683.84134375.0655746 1.28679687.0655746 2.49107422 0 4.78425391-.8363654 6.61547657-2.2631539-2.34264063-.0492187-4.30584375-1.5743942-4.98225-3.6735865.32997656.0491682.65990234.0819807 1.00638281.0819807.47841016 0 .95687109-.065625 1.40227344-.1803677-2.44161328-.4920361-4.27288672-2.6239904-4.27288672-5.19876206v-.06557452c.70936328.39359856 1.53430469.63959135 2.40860547.67235336-1.43528125-.95120913-2.37559766-2.57477163-2.37559766-4.4115649 0-.98397115.26391016-1.88596154.72586719-2.67315865 2.62310547 3.21436298 6.56601562 5.3135048 10.98728513 5.54314182-.0824687-.39359855-.1319804-.80355288-.1319804-1.21355769 0-2.91920192 2.3756484-5.29714904 5.3286796-5.29714904 1.5342539 0 2.9200235.63959135 3.8933985 1.67278125 1.2042773-.22958654 2.3590937-.67240384 3.3819805-1.27918269-.3959922 1.23001442-1.237336 2.26320433-2.3426407 2.91915144 1.0723477-.11474279 2.1116875-.4100048 3.0685078-.81995913-.7257656 1.04954567-1.6331757 1.98429808-2.6725156 2.73873317z"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                </svg>
              </a>
              <a href="http://instagram.com/oxacobbc" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 23 23" width="15" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m11.5051111 5.63474388c-3.25066666 0-5.87266666 2.62783964-5.87266666 5.88574612 0 3.2579064 2.622 5.8857461 5.87266666 5.8857461 3.2506667 0 5.8726667-2.6278397 5.8726667-5.8857461 0-3.25790648-2.622-5.88574612-5.8726667-5.88574612zm0 9.71224942c-2.10066666 0-3.81799999-1.7160356-3.81799999-3.8265033 0-2.11046773 1.71222222-3.82650336 3.81799999-3.82650336 2.1057778 0 3.818 1.71603563 3.818 3.82650336 0 2.1104677-1.7173333 3.8265033-3.818 3.8265033zm7.4826667-9.95300666c0 .76325167-.6133334 1.3728285-1.3697778 1.3728285-.7615556 0-1.3697778-.61469933-1.3697778-1.3728285 0-.75812918.6133334-1.37282851 1.3697778-1.37282851s1.3697778.61469933 1.3697778 1.37282851zm3.8895555 1.39331848c-.0868889-1.8389755-.506-3.46792873-1.8502222-4.81002227-1.3391111-1.34209354-2.9644444-1.76213808-4.7993333-1.85434298-1.8911111-.10757239-7.55933336-.10757239-9.45044447 0-1.82977777.0870824-3.45511111.50712694-4.79933333 1.84922049-1.34422222 1.34209354-1.75822222 2.97104677-1.85022222 4.81002227-.10733334 1.89532294-.10733334 7.57616927 0 9.47149217.08688889 1.8389755.506 3.4679288 1.85022222 4.8100223s2.96444444 1.7621381 4.79933333 1.854343c1.89111111.1075724 7.55933337.1075724 9.45044447 0 1.8348889-.0870824 3.4602222-.507127 4.7993333-1.854343 1.3391111-1.3420935 1.7582222-2.9710468 1.8502222-4.8100223.1073334-1.8953229.1073334-7.57104674 0-9.46636968zm-2.4431111 11.49999998c-.3986666 1.0040089-1.1704444 1.7775056-2.1773333 2.1821827-1.5077778.5993318-5.0855556.4610244-6.7517778.4610244-1.66622221 0-5.2491111.1331849-6.75177777-.4610244-1.00177777-.3995546-1.77355555-1.1730513-2.17733333-2.1821827-.598-1.5111358-.46-5.0968819-.46-6.7668151 0-1.66993321-.13288889-5.2608018.46-6.76681517.39866667-1.00400891 1.17044444-1.77750556 2.17733333-2.18218263 1.50777778-.59933184 5.08555556-.46102449 6.75177777-.46102449 1.6662222 0 5.2491111-.13318486 6.7517778.46102449 1.0017778.39955457 1.7735555 1.17305123 2.1773333 2.18218263.598 1.51113586.46 5.09688196.46 6.76681517 0 1.6699332.138 5.2608018-.46 6.7668151z"
                    fill="#fff"
                  />
                </svg>
              </a>
            </div>
          </Container>
        </StyledHero>

        <div id="homeContent">
          <Container>
            <div id="matches">
              <h1 id="hashTag">
                <span style={{ fontSize: '0.5em' }}>WE ARE</span>
                <br />
                #TEAMGREEN
              </h1>
              <HeroMatches />
            </div>
            <SyledAnnouncements>
              {data &&
                data.allContentfulMededeling &&
                data.allContentfulMededeling.edges.map(announcement => {
                  const {
                    contentful_id,
                    titel,
                    hoofdafbeelding,
                    korteOmschrijving,
                  } = announcement.node;
                  return (
                    <Card
                      key={contentful_id}
                      link={`/${slugify(titel)}`}
                      title={titel}
                      image={<Img fixed={hoofdafbeelding.fixed} />}
                      body={korteOmschrijving}
                      clickable
                    />
                  );
                })}
            </SyledAnnouncements>
            <section
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'stretch',
                justifyContent: 'space-between',
                maxWidth: '1200px',
                margin: '0 auto',
              }}
            >
              <div id="leftSide">
                {clubGames && clubGames && (
                  <Calendar
                    id="index"
                    games={clubGames.filter(game =>
                      moment(game.datumString, 'DD-MM-YYYY').isSame(new Date(), 'week')
                    )}
                    title="Wedstrijden deze week"
                  />
                )}

                <div id="gameRecaps">
                  <h2>Wedstrijdverslagen</h2>
                  {data &&
                    data.allContentfulWedstrijdverslag &&
                    data.allContentfulWedstrijdverslag.edges.map(gameReport => (
                      <GameReviewCard
                        key={gameReport.node.contentful_id}
                        url={`/${slugify(gameReport.node.titel)}`}
                        image={gameReport.node.hoofdafbeelding}
                        title={gameReport.node.titel}
                        excerpt={
                          gameReport.node.childContentfulWedstrijdverslagVerslagTextNode
                            .childMarkdownRemark.excerpt
                        }
                        date={gameReport.node.createdAt}
                      />
                    ))}
                </div>
              </div>
              <div id="rightSide">
                <Link to="/aansluiten" style={{ textDecoration: 'none' }}>
                  <StyledJoinCTA>
                    <img src={logo} id="ctaLogo" alt="Oxaco wings logo" />
                    <h2>Aansluiten bij Oxaco BBC</h2>
                    <img src={arrowRight} id="ctaArrow" alt="arrow right" />
                  </StyledJoinCTA>
                </Link>
                <a href="https://www.trooper.be/oxacobbc" target="_blank" rel="noopener noreferrer">
                  <img
                    src={trooper}
                    alt="trooper-logo"
                    id="trooper"
                    style={{ maxWidth: '200px', height: 'auto', marginBottom: '40px' }}
                  />
                </a>
                <div id="tweets">
                  <Tweets />
                </div>
              </div>
            </section>
          </Container>
        </div>
      </div>
    </Layout>
  );
};

export default Index;

export const heroQuery = graphql`
  query {
    allContentfulMededeling(
      sort: { fields: updatedAt, order: DESC }
      filter: { uitgelicht: { eq: true } }
      limit: 4
    ) {
      edges {
        node {
          titel
          contentful_id
          korteOmschrijving
          hoofdafbeelding {
            fixed(width: 290, height: 200) {
              ...GatsbyContentfulFixed
            }
          }
        }
      }
    }
    allContentfulWedstrijdverslag(limit: 8) {
      edges {
        node {
          contentful_id
          titel
          auteur
          ploeg {
            naam
            guid
          }
          hoofdafbeelding {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
          createdAt
          childContentfulWedstrijdverslagVerslagTextNode {
            childMarkdownRemark {
              html
              excerpt
            }
          }
        }
      }
    }
  }
`;
